const SUPPORTED_LANGUAGES = new Set(["en", "ar", "de", "es", "fr"]);
const DEFAULT_LANGUAGE = "en";

function normalizeSupportedLanguage(language?: string | null): string | null {
  const baseLanguage = language?.split("-")[0]?.toLowerCase() ?? "";
  return SUPPORTED_LANGUAGES.has(baseLanguage) ? baseLanguage : null;
}

export function currentLanguagePrefix(pathname?: string): string {
  const currentPathname =
    pathname ?? (typeof window !== "undefined" ? window.location.pathname : "");
  const maybeLang = currentPathname.split("/").filter(Boolean)[0] ?? "";
  return SUPPORTED_LANGUAGES.has(maybeLang) ? `/${maybeLang}` : "";
}

export function activeLanguagePrefix(pathname?: string): string {
  const pathPrefix = currentLanguagePrefix(pathname);
  if (pathPrefix) return pathPrefix;

  if (typeof document === "undefined") return "";

  const activeLanguage = normalizeSupportedLanguage(document.documentElement.lang);
  return activeLanguage && activeLanguage !== DEFAULT_LANGUAGE
    ? `/${activeLanguage}`
    : "";
}

export function localizedPath(path: string, pathname?: string): string {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  if (normalizedPath === "/") {
    return activeLanguagePrefix(pathname) || "/";
  }

  const firstSegment = normalizedPath.split("/").filter(Boolean)[0];
  if (normalizeSupportedLanguage(firstSegment)) {
    return normalizedPath;
  }

  return `${activeLanguagePrefix(pathname)}${normalizedPath}`;
}
